import { z } from "zod";

/** Handing an invoice to another member: who, and whether their approval is the only one counted. */
export const incomingInvoiceApprovalHandoverSchema = z.object({
	userId: z.string().min(1),
	isSoleApprover: z.boolean(),
});

export type IncomingInvoiceApprovalHandoverSchema = z.infer<
	typeof incomingInvoiceApprovalHandoverSchema
>;
